import classNames from 'classnames';
import $ from 'jquery';
import {map, orderBy, some} from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import swal from 'sweetalert2';
import {
  fetchInAndOut,
  postInAndOut,
  SUCCESS_IN_AND_OUT,
  SUCCESS_POST_IN_AND_OUT,
} from '../../../../../actions/entities/player';
import './CheckPlayers.css';

const initialState = {
  response: null,
  playersIn: {},
  playersOut: {},
  isSending: false,
  options: {},
};
class CheckPlayers extends React.Component {
  state = initialState;

  open = (options = {}) => {
    const {championship} = this.props;
    this.props.dispatch(fetchInAndOut({championship})).then(res => {
      if (res && res.type === SUCCESS_IN_AND_OUT) {
        this.setState({response: res.response});
      }
    });
    this.setState({options});
  };

  onSubmit = () => {
    const {championship} = this.props;
    const {options} = this.state;
    if (options.onSubmit) {
      options.onSubmit();
      $('#checkPlayers').modal('hide');
    } else {
      this.setState({isSending: true});
      const players = [
        ...map(this.state.playersIn, (value, id) => ({
          id,
          active: value === true ? 1 : 0,
        })),
        ...map(this.state.playersOut, (value, id) => ({
          id,
          active: value === true ? 0 : 1,
        })),
      ];
      this.props.dispatch(postInAndOut({championship, players})).then(res => {
        if (res && res.type === SUCCESS_POST_IN_AND_OUT) {
          this.setState(initialState);
          options.onSuccess && options.onSuccess();
          $('#checkPlayers').modal('hide');
          swal({
            title: `In & out confirmed !`,
            type: 'success',
            html: ``,
          });
        }
      });
    }
  };

  changePlayerStatus = (key, id, value) => () =>
    this.setState({[key]: {...this.state[key], [id]: value}});

  changeAllPlayersStatus = ({key, value}) => {
    const players = this.state.response[key];

    const playersStatus = {};
    players.forEach(({id}) => {
      playersStatus[id] = value;
    });

    this.setState({[key]: playersStatus});
  };

  renderButtons = key => {
    return (
      <div className="button-container">
        <button
          className="btn btn-success"
          onClick={() =>
            this.changeAllPlayersStatus({
              key,
              value: true,
            })
          }>
          <i className="fa fa-check-circle" /> All
        </button>
        <button
          className="btn btn-danger"
          onClick={() =>
            this.changeAllPlayersStatus({
              key,
              value: false,
            })
          }>
          <i className="fa fa-times-circle" /> All
        </button>
      </div>
    );
  };

  renderPlayers = (key, clubsById) => {
    const players = this.state.response[key];

    return (
      <table className="table table-responsive table-striped">
        <thead>
          <tr>
            <th>Team</th>
            <th className="id">ID</th>
            <th>Name</th>
            <th>Quot.</th>
            {!this.state.options.onSubmit && (
              <React.Fragment>
                <th />
                <th />
              </React.Fragment>
            )}
          </tr>
        </thead>
        <tbody>
          {map(
            orderBy(players, 'quotation', 'desc'),
            ({id, firstName, lastName, clubId, quotation}, index) => (
              <tr
                key={index}
                id={id}
                className={classNames('player', {
                  greenPlayer: this.state[key][id] === true,
                  redPlayer: this.state[key][id] === false,
                })}>
                <td data-id={clubId} title={clubId}>
                  {clubsById &&
                    clubsById[clubId] &&
                    clubsById[clubId].name['fr-FR']}
                </td>
                <td className="id">
                  {id && id.replace('mpg_championship_player_', '')}
                </td>
                <td>
                  {firstName} <span className="text-uppercase">{lastName}</span>
                </td>
                <td className="text-center">{quotation}</td>
                {!this.state.options.onSubmit && (
                  <React.Fragment>
                    <td
                      className="icon green"
                      onClick={this.changePlayerStatus(key, id, true)}>
                      <i className="fa fa-check-circle" />
                    </td>
                    <td
                      className="icon red"
                      onClick={this.changePlayerStatus(key, id, false)}>
                      <i className="fa fa-times-circle" />
                    </td>
                  </React.Fragment>
                )}
              </tr>
            ),
          )}
        </tbody>
      </table>
    );
  };

  canSubmit = () => {
    const {playersOut, playersIn} = this.state;
    const allPlayers = [
      ...this.state.response.playersOut,
      ...this.state.response.playersIn,
    ];
    const allPlayersConfirmed = {...playersOut, ...playersIn};
    return !some(allPlayers, player => allPlayersConfirmed[player.id] == null);
  };

  render() {
    const {response, options} = this.state;
    return (
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal">
            &times;
          </button>
          <h4 class="modal-title">{options.title || 'Confirm in & out ?'}</h4>
        </div>
        <div class="modal-body">
          {response && (
            <div id="check-players">
              <h4>Joueurs In</h4>
              {this.renderButtons('playersIn')}
              {this.renderPlayers('playersIn', this.props.clubsById)}
              <h4>Joueurs Out</h4>
              {this.renderButtons('playersOut')}
              {this.renderPlayers('playersOut', this.props.clubsById)}
              <div class="modal-footer">
                <button
                  disabled={!options.onSubmit && !this.canSubmit()}
                  onClick={this.onSubmit}
                  type="button"
                  class="btn btn-success">
                  Submit
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

CheckPlayers.propTypes = {
  championship: PropTypes.number,
};

export default connect(null, dispatch => ({dispatch}), null, {
  forwardRef: true,
})(CheckPlayers);



// WEBPACK FOOTER //
// ./src/pages/OnSite/FullPlayers/Widgets/CheckPlayers/index.js